import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/settings/")({
  component: SettingsIndex,
});

interface SettingsLink {
  label: string;
  href: string;
  description: string;
}

interface SettingsSection {
  label: string;
  links: SettingsLink[];
}

const sections: SettingsSection[] = [
  {
    label: "Fermentation",
    links: [
      {
        label: "Parameters & Feed Lines",
        href: "/settings/fermentation-parameters",
        description:
          "Parameter types authored in protocols, and the feed lines they drive",
      },
      {
        label: "Formula Templates",
        href: "/settings/formula-templates",
        description: "Reusable formula definitions for computed parameters",
      },
      {
        label: "BrewControl",
        href: "/settings/topic-mappings",
        description: "Topic mappings for live sensor data",
      },
    ],
  },
  {
    label: "Harvest",
    links: [
      {
        label: "Batch Clearance",
        href: "/settings/batch-clearance",
        description: "Clearance definitions for batch release",
      },
    ],
  },
  {
    label: "Inventory",
    links: [
      {
        label: "Resources",
        href: "/settings/inventory/resources",
        description: "Resource definitions and categories",
      },
      {
        label: "Locations",
        href: "/settings/inventory/locations",
        description: "Storage and lab locations",
      },
      {
        label: "Manufacturers",
        href: "/settings/inventory/manufacturers",
        description: "Manufacturers for products and equipment",
      },
      {
        label: "Certificate Types",
        href: "/settings/inventory/certificate-types",
        description: "Certificate types for inventory items",
      },
      {
        label: "Equipment Types",
        href: "/settings/inventory/equipment-types",
        description: "Equipment type classifications",
      },
      {
        label: "Equipment Models",
        href: "/settings/inventory/equipment-models",
        description: "Equipment model definitions",
      },
    ],
  },
  {
    label: "Cleaning",
    links: [
      {
        label: "Cleaning Procedures",
        href: "/settings/cleaning-procedures",
        description: "Cleaning procedure definitions and forms",
      },
    ],
  },
  {
    label: "Devices",
    links: [
      {
        label: "Devices",
        href: "/settings/devices",
        description: "Register BrewLink nodes and gateway devices",
      },
    ],
  },
];

function SettingsIndex() {
  return (
    <div className="container mx-auto px-4 py-6 flex flex-col grow min-h-0 gap-6">
      <div>
        <h1 className="text-lg font-semibold">Settings</h1>
        <p className="text-sm text-muted-foreground">
          System configuration and definitions.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {sections.map((section) => (
          <div key={section.label} className="space-y-1">
            <h2 className="text-sm font-medium mb-2">{section.label}</h2>
            {section.links.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="block px-3 py-2 -mx-1 hover:bg-muted/50 transition-colors"
              >
                <div className="text-sm font-medium">{link.label}</div>
                <div className="text-xs text-muted-foreground">
                  {link.description}
                </div>
              </Link>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
